import { render, staticRenderFns } from "./SprintWorkItemSelection.vue?vue&type=template&id=6d248fe6&scoped=true"
import script from "./SprintWorkItemSelection.vue?vue&type=script&lang=js"
export * from "./SprintWorkItemSelection.vue?vue&type=script&lang=js"
import style0 from "./SprintWorkItemSelection.vue?vue&type=style&index=0&id=6d248fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d248fe6",
  null
  
)

export default component.exports